/* eslint-disable @typescript-eslint/no-explicit-any */
import { isInternalTraffic } from './internal'

declare global {
  interface Window {
    _hsp: any[]
    _hsq: any[]
    disableHubSpotCookieBanner: boolean
  }
}

if (typeof window !== 'undefined') {
  window.disableHubSpotCookieBanner = true
}

/**
 * Always resolve from window at call time so early pushes
 * are queued on the real array that HubSpot reads when it loads.
 */
export const getHsp = (): any[] => {
  if (isInternalTraffic()) return []
  if (typeof window !== 'undefined') {
    window._hsp = window._hsp || []
    return window._hsp
  }
  return []
}

export const getHsq = (): any[] => {
  if (isInternalTraffic()) return []
  if (typeof window !== 'undefined') {
    window._hsq = window._hsq || []
    return window._hsq
  }
  return []
}
